'use strict';

var ProductComparePageView = require('./hpe.product.compare.page.view');
var CompareLoaderModel = require('./hpe.product.compare.page.model');

module.exports = (function() {

	function initialize() {

        var defaultState = {};
        var el = document.querySelector('.hpe-catalog-compare');
        var rootElement = document.querySelector('.hpe-product-compare-page');

        //i18n elements from DOM in model initialization default state
        if (rootElement) {
            defaultState.i18nAddAnother = rootElement.getAttribute('data-i18n-add-more') || '';
        }

        if (el) {
            new ProductComparePageView({
                el: el,
                model: new CompareLoaderModel(defaultState)
            });
        }
	}

	// Public methods
	return {
		initialize: initialize
	};

})();
